<template>
  <section id="test-vocacional">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-10 mx-auto d-flex justify-content-center align-items-center">
          <div class="content-wrapper my-5 bg-white rounded p-4 pb-5 w-100 position-relative">
            <!-- body -->
            <div class="row mt-5 row mt-0 mt-md-4">
              <div class="col-12 text-center">
                <h3 class="text-size-titulo1 text-primary mt-0 pb-3 mb-3 text-center">¡Gracias!</h3>
                <p class="text-center">En breve recibirás un mail con toda la información.</p>
                <a href="https://www.ucam.edu/" class="btn btn-lg btn-primary mt-3 font-weight-normal"> Visitar ucam.edu </a>
              </div>
            </div>
            <!-- ./end body -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import {useQuestionStore} from "@/stores/question.js";

const questionStore = useQuestionStore();
</script>

<style scoped>

</style>
